import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import HikeCard from '../components/HikeCard';
import Spinner from '../components/Spinner';
import Footer from '../components/Footer';

export default function MyHikesPage() {
  const navigate = useNavigate();
  const { token, registeredHikesData, organizedHikes: cachedOrganizedHikes, loadUserProfile } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Use cached data from AuthContext (loaded during login with ?include parameter)
  const myHikes = registeredHikesData || [];
  const organizedHikes = cachedOrganizedHikes || [];

  useEffect(() => {
    const initializeData = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        // Always load user profile to ensure we have the latest organized hikes
        await loadUserProfile(token);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    initializeData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <Spinner size="md" color="blue" />
          <div className="text-sm text-gray-600">Caricamento gite...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 max-w-sm">
          <h2 className="text-lg font-semibold text-red-600 mb-2">Errore</h2>
          <p className="text-sm text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => navigate(-1)}
            className="w-full bg-blue-600 text-white py-2 rounded text-sm font-medium hover:bg-blue-700 transition"
          >
            Torna Indietro
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 py-4">
        {/* Organized Hikes Section */}
        {organizedHikes.length > 0 && (
          <div className="mb-6">
            <h1 className="text-lg font-semibold text-gray-800 mb-4">Gite Organizzate da Me</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {organizedHikes.map(hike => (
                <HikeCard key={hike.id} hike={hike} />
              ))}
            </div>
          </div>
        )}

        {/* Registered Hikes Section */}
        <h1 className="text-lg font-semibold text-gray-800 mb-4">Le Mie Iscrizioni</h1>

        {myHikes.length === 0 ? (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 text-center">
            <p className="text-sm text-gray-600 mb-2">Non sei ancora iscritto a nessuna gita.</p>
            <p className="text-xs text-gray-500">Esplora le gite disponibili!</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {myHikes.map(hike => (
              <HikeCard key={hike.id} hike={hike} />
            ))}
          </div>
        )}

        <Footer />
      </div>
    </div>
  );
}